import React from 'react';
import {MessageCircleDashed as MessageCircle} from 'lucide-react';

export default function WhatsAppButton() {
  const phoneNumber = '351967905983'; // Formato internacional: 351 (Portugal) + número
  const message = 'Olá! Gostaria de saber mais sobre os vossos serviços.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:bg-[#20BD5A] transition-all transform hover:scale-110 group animate-bounce-slow"
      aria-label="Contactar via WhatsApp"
    >
      <MessageCircle className="h-7 w-7" />
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 hidden group-hover:block">
        <div className="bg-gray-900 text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap shadow-lg">
          Fale connosco via WhatsApp
          <div className="absolute top-full right-4 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-gray-900"></div>
        </div>
      </div>
    </a>
  );
}